import React from 'react';

import { Typography, CardMedia, Box } from '@material-ui/core';
import ES from 'components/ExplainString';
import Experience from 'components/Experience';
import ProjectLink from 'components/ProjectLink';


import explains from 'data/explains'

import {Grid} from '@material-ui/core';

export default function gen(props){
  return (<Box>
        <Typography>
          While doing placements and personal projects, I understand management and communication are crucial for smooth development. <br />
        </Typography>

        {/* Bullet Point */}
        <Typography component="div">
          <ul>
            <li>I learned requirements gathering, giving people what they need</li>
            <li>I'm an expert at Git, can write hooks, rebase, use reflog and cherry-pick</li>
            <li>I understand the importance of branches and split the code into smaller chunks for review.</li>
            <li>I use Issue and Milestone to ensure the deadline is met</li>
            <li>I write unit test and use <ES {...explains['Travis']}/> to verify code before its merged</li>

          </ul>
        </Typography>
  </Box>)
}
